/* global google */
import React, { Component } from 'react';                    
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';
import CurrenLocalizationPin from './CurrenLocalizationPin';
import { PinContainer } from './CarwashLocalizationPin';
import { connect } from "react-redux";
import { activeInit, activeChange } from "./../actions";
import SearchedLocalizationPin from './SearchedLocalizationPin';

const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");

async function searchGeocoding(zoom, country, street, getSearchedPlace, realizations, getNearbyWashesFn, radius) {
    let geocoder = new google.maps.Geocoder();

    await geocoder.geocode( { 'address': country + ' ' + street }, async function(results, status) {
        if (status == 'OK') {
            let center = {
                latitude: results[0].geometry.location.lat(), 
                longitude: results[0].geometry.location.lng(),
            } 
            let resNew = await getSearchedPlace(results, zoom);
            await getNearbyWashes( center, resNew, getNearbyWashesFn, radius );
        } else {
            await getSearchedPlace(null, zoom);
            
        }
        return false;
    });
    
}
async function getNearbyWashes(center, realizations, getNearbyWashesFn, radius) {
    let nearby = [];
    if ( !window.google ) {
        return false;
    }
    let centerPoint = new google.maps.LatLng(center.latitude, center.longitude);
    await realizations.map( el => {
        let realizationPoint = new google.maps.LatLng(el[0].device_latitude, el[0].device_longitude);
        let distance = google.maps.geometry.spherical.computeDistanceBetween(centerPoint, realizationPoint);
        distance = (distance/1000).toFixed(2);
        let R = radius;

        if (distance <= R) {
            let object = el;
            object[0].distance = distance;
            nearby = [...nearby, object];
        }
    })
    await nearby.sort(function(a,b) {
        var x = parseFloat(a[0].distance)
        var y = parseFloat(b[0].distance)
        return x < y ? -1 : x > y ? 1 : 0;
    });
    await getNearbyWashesFn(nearby);
    return false;
}
const MapWithAMarker = withScriptjs(withGoogleMap(props =>
    <GoogleMap
        defaultCenter={ { lat: props.center.latitude , lng: props.center.longitude } }
        center={ { lat: props.center.latitude , lng: props.center.longitude } }
        defaultZoom={ props.zoom }
        zoom={ props.zoom }    
        defaultOptions={{ mapTypeControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT } }}
    >
        { props.allowGeo && 
            <CurrenLocalizationPin
                lat={ parseFloat(props.coords.latitude) }
                lng={ parseFloat(props.coords.longitude) }
            />
        }
        { props.aggregate == 'on' && 
            <MarkerClusterer
                averageCenter
                enableRetinaIcons
                gridSize={60}
                styles={[		
                    {		
                    url: props.m1,		
                    height: 32,		
                    width: 32,		
                    fontFamily:"Lato",		
                    textColor:"#FFF",		
                },		
                {		
                    url: props.m2,		
                    height: 34,		
                    width: 34,		
                    fontFamily:"Lato",		
                    textColor:"#FFF",		
                },		
                {		
                    url: props.m3,		
                    height: 34,		
                    width: 34,		
                    fontFamily:"Lato",		
                    textColor:"#FFF",		
                },		
                {		
                    url: props.m4,		
                    height: 40,		
                    width: 40,		
                    fontFamily:"Lato",		
                    textColor:"#FFF",		
                },		
                {		
                    url: props.m5,		
                    height: 46,		
                    width: 46,		
                    fontFamily:"Lato",		
                    textColor:"#FFF",		
                } 		
                ]}
                calculator={(markers, numStyles ) => {
                    var index = 0;
                    var count = markers.length.toString();
                
                    var dv = count;
                    while (dv !== 0) {
                    dv = parseInt(dv / 4, 10);
                    index++;
                    }
                
                    index = Math.min(index, numStyles);
                    return {
                    text: "",
                    index: index,
                    title: ""
                    };
                }}>

                { props.realizations && props.realizations.map( (el, index) => (
                    <PinContainer
                        key={ index }
                        keyItem={ index }
                        lat={ parseFloat(el[0].device_latitude) }
                        lng={ parseFloat(el[0].device_longitude) }
                        data={ el } 
                        options={ props.options}
                        iconMap={ props.iconMap }
                        domain={ props.domain }
                        iconType={ props.iconType } 
                        iconCount={ props.iconCount } 
                        changeActiveTemp={ (val) => props.changeActiveTemp(val) }
                        seeOnMap={ (lat, lang) => props.seeOnMap(lat, lang) }
                        />
                ))}

            </MarkerClusterer>
        }
        { props.aggregate == '' ||  props.aggregate == 'off' && 
            <>
                { props.realizations && props.realizations.map( (el, index) => (
                    <PinContainer
                        key={ index }
                        keyItem={ index }
                        lat={ parseFloat(el[0].device_latitude) }
                        lng={ parseFloat(el[0].device_longitude) }
                        data={ el } 
                        domain={ props.domain }
                        options={ props.options}
                        iconMap={ props.iconMap }
                        iconType={ props.iconType } 
                        iconCount={ props.iconCount } 
                        changeActiveTemp={ (val) => props.changeActiveTemp(val) }
                        seeOnMap={ (lat, lang) => props.seeOnMap(lat, lang) }
                        />
                ))}
            </>
        }
        
        { props.searchedItem && props.searchedItem.map( (el, index) => (
            <SearchedLocalizationPin
                key={ index }
                lat={ parseFloat(el.geometry.location.lat()) }
                lng={ parseFloat(el.geometry.location.lng()) }
            />
        )) }
    </GoogleMap>
));

class GoogleMapsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searching: false,
            opened: false,
        }
    }
    async componentDidMount() {
        await this.props.activeInit();
    }
    async componentDidUpdate(prevProps, prevState) {
        if ( prevProps.country != this.props.country) {
            await searchGeocoding( 6, this.props.country, this.props.street, this.props.getSearchedPlace, this.props.realizations, this.props.getNearbyWashes, this.props.radius )
        }
        if ( prevProps.search != this.props.search) {
            await searchGeocoding( 13, this.props.country, this.props.street, this.props.getSearchedPlace, this.props.realizations, this.props.getNearbyWashes, this.props.radius )
            // await getNearbyWashes( this.props.center, this.props.realizations, this.props.getNearbyWashes, this.props.radius );
        }
        if ( prevProps.allowGeo != this.props.allowGeo  ) {
            await getNearbyWashes( this.props.center, this.props.realizations, this.props.getNearbyWashes, this.props.radius );
        }
        if ( prevProps.center != this.props.center  && !this.props.seeOnMap) {
            await getNearbyWashes( this.props.center, this.props.realizations, this.props.getNearbyWashes, this.props.radius );
        }
        if ( prevProps.activeTemp != this.props.activeTemp) {
           await this.props.activeChange(this.props.activeTemp);
        }


        // (street, getSearchedPlace, onlyCountry, realizations, getNearbyWashesFn, radius) {
    }
    render() {
        return (
            <MapWithAMarker
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyD8voO99fkLyc_LjKKGaF-LA2aPxVhZJKM&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `calc(100vh - 103px - 36px - 50px)` }} />}
                mapElement={<div style={{ height: `100%` }} id="main-map"/> } 
                zoom={ this.props.zoom } 
                center={ this.props.center } 
                options={ this.props.options } 
                coords={ this.props.coords } 
                allowGeo={ this.props.allowGeo } 
                realizations={ this.props.realizations } 
                getSearchedPlace={ (data) => this.props.getSearchedPlace(data) } 
                searchedItem={ this.props.searchedItem } 
                iconMap={ this.props.iconMap }
                iconType={ this.props.iconType } 
                iconCount={ this.props.iconCount } 
                active={ this.props.active }
                changeActiveTemp={ (val) => this.props.changeActiveTemp(val) }
                seeOnMap={ (lat, lang) => this.props.seeOnMap(lat, lang) } 
                m1={ this.props.m1 }
                m2={ this.props.m2 }
                m3={ this.props.m3 }
                m4={ this.props.m4 }
                m5={ this.props.m5 }
                domain={ this.props.domain }
                aggregate={ this.props.aggregate } />
            )
    

    }
}
const mapStateToProps = state => {
    return {
        active: state.active,
    };
  };
  
  const mapDispatchToProps = { activeInit, activeChange };
  
  export const GoogleMapsComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
  )(GoogleMapsComponent);